import SwapHorizIcon from '@mui/icons-material/SwapHoriz';
import BoltIcon from '@mui/icons-material/Bolt';
import AirIcon from '@mui/icons-material/Air';
import SpeedIcon from '@mui/icons-material/Speed';
import StraightenIcon from '@mui/icons-material/Straighten';
import GrainIcon from '@mui/icons-material/Grain';
import SettingsIcon from '@mui/icons-material/Settings';

export const tools = [
  {
    path: '/specific-power',
    title: 'Specific Power',
    description: 'Work out compressor specific power, specific energy, and efficiency from package kW and FAD.',
    icon: BoltIcon,
  },
  {
    path: '/converter',
    title: 'Unit Converter',
    description: 'Convert length, pressure, flow, power, and other industrial units.',
    icon: SwapHorizIcon,
  },
  {
    path: '/fad',
    title: 'Free Air Delivery',
    description: 'Correct a measured flow back to free air delivery conditions.',
    icon: AirIcon,
  },
  {
    path: '/pressure-drop',
    title: 'Pressure Drop',
    description: 'Estimate compressed-air pipe pressure drop with Darcy-Weisbach.',
    icon: SpeedIcon,
  },
  {
    path: '/cylinder',
    title: 'Cylinder Force',
    description: 'Calculate pneumatic cylinder force, area, and swept volume.',
    icon: StraightenIcon,
  },
  {
    path: '/sandblasting',
    title: 'Sandblasting',
    description: 'Estimate blasting efficiency from nozzle, pressure, and media flow.',
    icon: GrainIcon,
  },
  {
    path: '/belt-size',
    title: 'Belt Size',
    description: 'Calculate belt length, speed ratio, and wrap angle.',
    icon: SettingsIcon,
  },
];
